import React, { useState, useRef } from "react";
import document from "../../../assets/images/doc.png";
import PostData from "../../../api/PostData";
import AppData from "../../../config/appData.json";
import CustomSelect from "../../../components/customSelect/CustomSelect";

export default function GatewaySettlement({ fileUploadHistory }) {
  const [err, setErr] = useState(false);
  const [msg, setMsg] = useState("");
  const [files, setFiles] = useState(null);
  const [sheetNo, setSheetNo] = useState("");
  const [sheetCount, setSheetCount] = useState(0);
  const [sheetOptions, setSheetOptions] = useState("");
  const inputRef = useRef();
  const url = AppData.BASE_URL + "settlements/uploads";
  const data = {
    pid: "pid",
    itemCount: "itemCount",
    filename: "filename",
    processor: "processor",
    data: "data",
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setFiles(e.dataTransfer.files);
  };

  const UploadFile = (e) => {
    e.preventDefault();
    PostData(url, data).then((result) => {
      const { error, message } = result;
      if (error) {
        setErr(true);
        setMsg(message[0]);
        return;
      }
    });
  };

  const handleSheetCountChange = (e) => {
    const count = parseInt(e.target.value);
    setSheetCount(count);
    setSheetOptions(Array(count).fill("Select Switch"));
  };

  const handleOptionChange = (index, value) => {
    const newOptions = [...sheetOptions];
    newOptions[index] = value;
    setSheetOptions(newOptions);
    console.log("shdgd", newOptions);
  };

  console.log("sheet option", sheetOptions);

  return (
    <div className="gateway-settlement">
      <div className="file-upload justify-content-start">
        <div className="file-upload-card">
          <div
            className="file-upload-area"
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            onClick={() => inputRef.current.click()}
          >
            <input
              type="file"
              accept=".xlsx, .csv"
              onChange={(e) => setFiles(e.target.files)}
              hidden
              ref={inputRef}
            />
            <div className="d-flex justify-content-center">
              <img src={document} alt="document" />
            </div>
            <p className="text-center mt-2">
              Select An Excel File To Upload <br /> Or Drag File Here
            </p>
          </div>
        </div>
      </div>
      <div className="row mt-2 mb-3">
        <div className="col-2">
          <div className="grouped-input">
            <label htmlFor="firstName">Enter Number of Sheets:</label>
            <input
              type="number"
              className="form-control"
              value={sheetCount}
              onChange={handleSheetCountChange}
              placeholder="Enter No here"
              min="0"
              max="5"
            />
          </div>
        </div>
      </div>
      <div className="d-flex gap-2">
        {Array.from({ length: sheetCount }, (_, index) => (
          <div className="sheet-option" key={index}>
            <CustomSelect
              heading={`Sheet ${index + 1}`}
              selectedVal={sheetOptions[index] || "Select Switch"}
              setSelectedValue={(value) => handleOptionChange(index, value)}
              items={[
                { name: "Ignore this sheet" },
                { name: "Settlement_record" },
                { name: "Settle UPSL" },
              ]}
              defaultOption={{ label: "Select Switch", value: "" }}
            />
          </div>
        ))}
      </div>
      <button onClick={UploadFile} className="btn btn-primary mt-3">
        Upload
      </button>
      {err && <p className="error-msg">{msg}</p>}
    </div>
  );
}
